<script setup>
import EmailingAutomationPromoPriceRuleForm from '@frontJs/components/forms/projectManagement/modules/EmailingAutomationPromoPriceRuleForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, promoPriceRule, promoDiscountTypes, stores, customerGroups } =
    defineProps({
        tenant: {
            type: Object,
            required: false,
        },
        promoPriceRule: {
            type: Object,
            required: false,
        },
        promoDiscountTypes: {
            type: Array,
            required: true,
        },
        stores: {
            type: Array,
            required: true,
        },
        customerGroups: {
            type: Array,
            required: true,
        },
    });

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="promoPriceRule">
            Mettre à jour la règle de prix promo #{{ promoPriceRule.id }} -
            Emailings automatisés - Modules - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer une règle de prix promo - Emailings automatisés - Modules -
            Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="promoPriceRule" :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Mettre à jour la
        règle de prix promo #{{ promoPriceRule.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - Modules - Emailings automatisés - Créer une règle de
        prix promo
    </PageTitle>

    <EmailingAutomationPromoPriceRuleForm
        :promo-price-rule="promoPriceRule"
        :promo-discount-types="promoDiscountTypes"
        :stores="stores"
        :customer-groups="customerGroups"
        :tenant="tenant"
    />
</template>
